import { FirebaseFirestore } from "@firebase/firestore-types";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/analytics";
import "firebase/compat/functions";
import "firebase/compat/storage";
import { getFirebaseConfig } from "~/configs/firebase";

let app: firebase.app.App | undefined;

if (!firebase.apps.length) {
  const config = getFirebaseConfig();
  app = firebase.initializeApp(config);

  // if (firebase.analytics.isSupported()) {
  //   firebase.analytics();
  // }
} else {
  app = firebase.app();
}

export const signInOptions = [firebase.auth.EmailAuthProvider.PROVIDER_ID];
export const fieldPath = firebase.firestore.FieldPath;
export const fieldValue = firebase.firestore.FieldValue;
export const auth = firebase.auth();
export const db: FirebaseFirestore = firebase.firestore();
export const functions = firebase.app().functions("asia-northeast1");
export const storage = firebase.storage();

if (
  process.env.USE_FIREBASE_EMULATORS === "true" &&
  typeof window !== "undefined" &&
  window.location.hostname === "localhost"
) {
  const authEndpoint = "http://localhost:9099";
  const firestoreHost = process.env.FIRESTORE_EMULATOR_HOST || "localhost";
  const firestorePort = Number(process.env.FIRESTORE_EMULATOR_PORT || "9000");
  const functionsHost = process.env.FUNCTIONS_EMULATOR_HOST || "localhost";
  const functionsPort = Number(process.env.FUNCTIONS_EMULATOR_PORT || "5001");
  console.warn(
    `[Firebase emulator] Using ${process.env.USE_FIREBASE_AUTH_EMULATOR === "false" ? "DEV Auth" : `local Auth (${authEndpoint})`}, local Firestore (${firestoreHost}:${firestorePort}), and Functions (${functionsHost}:${functionsPort}). Data and operations are not production.`
  );
  if (process.env.USE_FIREBASE_AUTH_EMULATOR !== "false") {
    auth.useEmulator(authEndpoint);
  }
  db.useEmulator(
    firestoreHost,
    firestorePort
  );
  functions.useEmulator(
    functionsHost,
    functionsPort
  );
}
